import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="w-full bg-ink-900 px-4 py-10 sm:px-6 sm:py-14" data-id="element-79" data-mp="4uqdmw6js2tb">
      <div className="mx-auto max-w-xl text-center" data-id="element-80" data-mp="9ucq33ejxf12">
        <ShieldCheckIcon aria-hidden="true" strokeWidth={1.5} className="mx-auto h-14 w-14 text-gold-500 sm:h-16 sm:w-16" data-id="element-81" data-mp="9tl6ys2559ro" />

        <h2 className="mt-4 text-xl font-extrabold uppercase leading-tight text-gold-500 sm:text-3xl" data-id="element-82" data-mp="jssl3hgp98fu">
          Garantía 7 días — sin preguntas
        </h2>

        <div className="mt-5 rounded-xl border border-white/15 bg-ink-800 px-5 py-6" data-id="element-83" data-mp="nsb05wluapar">
          <p className="text-[13px] text-neutral-300 sm:text-base" data-id="element-84" data-mp="sldysj5h4oxt">
            Si en 7 días no es lo que esperabas:
          </p>
          <p className="mt-2 text-2xl font-extrabold leading-tight text-gold-500 sm:text-4xl" data-id="element-85" data-mp="xls07ickl0mv">
            devolución del 100%
          </p>
          <p className="mt-2 text-[13px] text-neutral-400 sm:text-base" data-id="element-86" data-mp="17j6cr6vdh59w">
            sin formularios, sin drama, sin esperas.
          </p>
        </div>
      </div>
    </section>;
}